import _ from 'lodash';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Table as RSTable } from 'reactstrap';
import { RootState } from '../../stores/store';

import './Table.scss';
import TableNavigation from './TableNavigation';
import TableSearch from './TableSearch';

interface Props extends LocalizeContextProps, RouteComponentProps {
    refresh: () => void;
    children: JSX.Element[];
    toolbar: JSX.Element;
    tableKey: string;
}

class Table extends React.Component<Props> {

    public render() {
        return (
            <React.Fragment>
                {this.props.toolbar}
                <TableSearch tableKey={this.props.tableKey} refresh={this.props.refresh} />
                <RSTable responsive={true}>
                    {this.props.children}
                </RSTable>
                <TableNavigation tableKey={this.props.tableKey} refresh={this.props.refresh} />
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: RootState) => ({

});

export default connect(mapStateToProps)(withLocalize(withRouter(Table)));